import { render } from "./Edit.vue?vue&type=template&id=1b629654&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=1b629654&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b629654"

export default script